import * as React from 'react';
import { ButtonColorsEnum } from '../../../constants/button-colors';
import { ButtonViewProps } from '../../actions/Button/Button.view';
import classNames from 'classnames';
import classes from './Modal.module.scss';
import { footerModalButton } from './Modal.view';

export type PrimaryButton = {
  primaryButtonTitle: string;
  primaryButtonAction: () => void;
  primaryButtonDisabled?: boolean;
  primaryButtonLoading?: boolean;
  primaryButtonColor?: ButtonColorsEnum;
  primaryButtonType?: Omit<ButtonViewProps['type'], 'a'>;
  footerContent?: never;
};

export type SecondaryButton = {
  secondaryButtonTitle: string;
  secondaryButtonAction: () => void;
  secondaryButtonDisabled?: boolean;
  secondaryButtonLoading?: boolean;
  secondaryButtonColor?: ButtonColorsEnum;
  secondaryButtonType?: Omit<ButtonViewProps['type'], 'a'>;
  footerContent?: never;
};

export type ModalFooterTemplateProps = {
  primaryContentPosition?: PrimaryButton;
  secondaryContentPosition?: SecondaryButton | JSX.Element | string;
  size?: 'small' | 'large' | 'fluid' | 'hugging' | 'zoom';
  hasScrollbar?: boolean;
};
export const ModalFooterTemplate = ({
  primaryContentPosition,
  secondaryContentPosition,
  size
}: ModalFooterTemplateProps): JSX.Element => {
  const buttonContainerClasses = classNames(
    classes.ButtonContainer,
    size === 'small'
      ? classes.ButtonContainerSmall
      : size === 'hugging'
      ? classes.ButtonContainerHugging
      : classes.ButtonContainerLarge,
    'grid-x',
    primaryContentPosition && secondaryContentPosition ? 'align-justify' : 'align-right',
    {
      [classes.InScrollMode]: true
    }
  );

  const primaryButton = primaryContentPosition
    ? footerModalButton(
        primaryContentPosition.primaryButtonTitle,
        true,
        true,
        false,
        primaryContentPosition.primaryButtonColor ?? ButtonColorsEnum.primary,
        'medium',
        primaryContentPosition.primaryButtonAction,
        primaryContentPosition.primaryButtonDisabled ?? false,
        primaryContentPosition.primaryButtonLoading,
        primaryContentPosition.primaryButtonType
      )
    : null;

  return (
    <div className={buttonContainerClasses}>
      {typeof secondaryContentPosition === 'string' ? (
        <div className={classes.SecondaryPositionLabel}>{secondaryContentPosition}</div>
      ) : undefined}
      {primaryButton}
    </div>
  );
};
